import { render, staticRenderFns } from "./model-type.vue?vue&type=template&id=5caa30d6&scoped=true&"
import script from "./model-type.vue?vue&type=script&lang=ts&"
export * from "./model-type.vue?vue&type=script&lang=ts&"
import style0 from "./model-type.vue?vue&type=style&index=0&id=5caa30d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa30d6",
  null
  
)

export default component.exports